export default {
  envName: 'stage',
  baseURL: 'https://stageapi.frontm.ai',
  filesAPI: 'https://gwuat.frontm.ai/proxy/resource',
  contentURL: 'https://gwuat.frontm.ai/proxy/botLogos/',
  botFilesAPI: 'https://gwuat.frontm.ai/proxy/resource/botfile?path=',
  paymentGatewayKey: process.env.REACT_APP_PAYMENT_GATEWAY_KEY,
  soundURL: 'https://gwuat.frontm.ai/proxy/sounds/',
  gRPCURL: 'https://gwuat.frontm.ai',
  webertcSignalServer: 'gwuat.frontm.ai',
  mapURL: 'https://maps.frontm.ai/styles/klokantech-basic/style.json',
  sipURI: 'frontmsecureweb@pstn-prod.frontm.ai',
  sipPassword: process.env.REACT_APP_SIP_PASSWORD,
  sipWebsocket: 'wss://pstn-prod.frontm.ai:8089/ws',
  dailyPlatformUrl: 'https://frontm.daily.co/',
  daily_baseUrl: 'https://x7kuu4sb32.execute-api.us-east-1.amazonaws.com/item/video',
  xApiKey: process.env.REACT_APP_X_API_KEY,
  userImageBaseUrl: "https://gwuat.frontm.ai/proxy/resource/file/profile-pics",

  defaultHomePagebaseUrl: "spinnetstage.frontm.ai",
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  websocketURL: 'wss://u8wr9j1kv8.execute-api.us-east-1.amazonaws.com/stage/',
  webSocketAPiKey: process.env.REACT_APP_WEBSOCKET_API_KEY,
  wpsGatewayRestApiKey: "https://5glogmvnrk.execute-api.us-east-1.amazonaws.com/stage",
  vikandWebPushKey: process.env.REACT_APP_VIKAND_WEB_PUSH_KEY,
  seamedexWebPushKey: process.env.REACT_APP_SEAMEDEX_WEB_PUSH_KEY,
  jwtLoginURL: 'https://5glogmvnrk.execute-api.us-east-1.amazonaws.com/stage',
  xApiKeyForJwtLogin: process.env.REACT_APP_X_API_KEY_JWT_LOGIN,
  dailyXApiKey: process.env.REACT_APP_DAILY_X_API_KEY,
  //Apptypes
  stationoneAppType: "stationsatcom",
  onshipAppType: "onship",
  vikandWebAppType: "vikand",
  seamedexAppType: "seamedix",
  seadanceAppType: "seadance",
  intelsatAppType: "intelsat",
  ledgidAppType: "ledgid",

  //authCode
  onshipDomain: 'onshipEndUser',
};
